import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FeedbackMessageComponent } from '../feedback-message/feedback-message.component';

@Component({
  selector: 'app-no-reports-found',
  imports: [CommonModule, FeedbackMessageComponent],
  templateUrl: './no-reports-found.component.html',
  styleUrl: './no-reports-found.component.scss',
})
export class NoReportsFoundComponent {}
